import styled from 'styled-components';

export const SpinnerContainer = styled.div`
    width: 100%;
    height: ${({ height }) => height || '100%'};
    background: ${({ background }) => background};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${({ marginTop }) => marginTop};
`;

export const StyledImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledImage = styled.img`
    width: ${({ width }) => width || '100%'};
    height: ${({ height }) => height || '100%'};
    object-fit: cover;
`;

export const ChildrenContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
